/**
 * 公共 - 英文（美版）
 * App common, login, common messages
 */
export default {
  app: {
    title: 'Smart Hardware Dealer Management System',
    emergencyContactSettingsTitle: 'Emergency Contact Settings',
    followUpStudentTitle: 'Follow-up Student',
    followUpStudentTabAddFollow: 'Add follow-up',
    followUpStudentTabCompleteProfile: 'Complete profile',
    followUpStudentStudentName: 'Student name',
    followUpStudentCustomerIntent: 'Customer intent',
    followUpStudentFollowStatus: 'Follow-up status',
    followUpStudentStudentTags: 'Student tags',
    followUpStudentCallCommStatus: 'Call status',
    followUpStudentFollowContent: 'Follow-up content',
    followUpStudentFollowContentTipLine1:
      'e.g. which follow-up visit this is; Squirrel AI strengths explained; subjects the student is interested in;',
    followUpStudentFollowContentTipLine2:
      "the parent's attitude; whether the next follow-up is scheduled; etc.",
    followUpStudentUploadImageHint:
      'JPG/PNG, recommended 1080×1920, max 5MB',
    followUpStudentCredentialSample: 'Sample credential',
    followUpStudentNextCommTime: 'Next contact time',
    followUpStudentSelectDate: 'Select date',
    followUpStudentSelectTime: 'Select time',
    followUpStudentPlaceholderSelectIntent: 'Select customer intent',
    followUpStudentPlaceholderSelectFollowStatus: 'Select follow-up status',
    followUpStudentPlaceholderFollowContent: 'Enter follow-up notes',
    followUpStudentPhone: 'Mobile',
    followUpStudentPlaceholderPhone: 'Enter mobile number',
    followUpStudentSex: 'Gender',
    followUpStudentMale: 'Male',
    followUpStudentFemale: 'Female',
    followUpStudentBirthday: 'Date of birth',
    followUpStudentPlaceholderBirthday: 'Select date of birth',
    followUpStudentHomeAddress: 'Home address',
    followUpStudentPlaceholderHomeAddress: 'Enter home address',
    followUpStudentStudentType: 'Student type',
    followUpStudentPlaceholderSelectStudentType: 'Select student type',
    followUpStudentStageGrade: 'Stage & grade',
    followUpStudentPlaceholderSelectStage: 'Select stage',
    followUpStudentPlaceholderSelectGrade: 'Select grade',
    followUpStudentSource: 'Source',
    followUpStudentStudentSchool: 'Student school',
    followUpStudentPlaceholderSelectSchool: 'Select school',
    followUpStudentCourseAdvisor: 'Course advisor',
    followUpStudentPlaceholderSelectAdvisor: 'Select course advisor',
    followUpStudentRegionOne: 'Region 1',
    followUpStudentRegionTwo: 'Region 2',
    followUpStudentContact1: 'Contact 1',
    followUpStudentPlaceholderContact1: 'Enter contact 1',
    followUpStudentContact2: 'Contact 2',
    followUpStudentPlaceholderContact2: 'Enter contact 2',
    followUpStudentContact3: 'Contact 3',
    followUpStudentPlaceholderContact3: 'Enter contact 3',
    followUpStudentRemark: 'Remark',
    followUpStudentPlaceholderRemark500: 'Within 500 characters',
    selectProductTitle: 'Select Product',
    uploadImageTitle: 'Upload Image',
    confirmDeleteComponent: 'Are you sure you want to delete this component?',
    logisticsDetailsTitle: 'Logistics Details',
    cannotSubscribeTipTitle: 'Cannot Subscribe Tip',
    paymentTitle: 'Payment',
    shipmentTitle: 'Shipment',
    assignCoursesTitle: 'Assign Courses',
    batchCancelAssignedCoursesTitle: 'Batch Cancel Assigned Courses',
    editSchoolTitle: 'Edit School',
    addSchoolTitle: 'Add School',
    editInfoTitle: 'Edit Information',
    addInfoTitle: 'Add Information',
    addInformationTitle: 'Add Information',
    addRelatedOrderTitle: 'Add Related Order',
    verificationPromptTitle: 'Verification Prompt',
    addInvoiceTitle: 'Add Invoice',
    addContractTitle: 'Add Contract',
    multipleSchoolQueryTitle: 'Multiple School Query',
    changeDetailsTitle: 'Change Details',
    subjectChangeWarningTitle: 'Subject Change Warning',
    editAccountTitle: 'Edit Account',
    addAccountTitle: 'Add Account',
    agentInitialAccountAmountTitle: 'Agent Initial Account Amount',
    cashRechargeTitle: 'Cash Account Recharge',
    switch: 'Switch',
    enable: 'Enable',
    disable: 'Disable',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    refreshStatus: 'Refresh Status',
    export: 'Export',
    exportDetail: 'Export Detail',
    import: 'Import',
    upload: 'Upload',
    download: 'Download',
    done: 'Done',
    next: 'Next',
    nextStep: 'Next',
    prevStep: 'Previous',
    downloadImportTemplate: 'Download Import Template',
    operation: 'Operation',
    detail: 'Detail',
    details: 'Details',
    userDetail: 'User Details',
    submit: 'Submit',
    back: 'Back',
    labelColon: ': ',
    loading: 'Loading...',
    pleaseEnter: 'Please enter',
    yuan: 'yuan',
    complete: 'Complete',
    success: 'Operation successful',
    saveSuccess: 'Saved successfully',
    uploadSuccess: 'Upload successful',
    uploadFail: 'Upload failed',
    uploadFileSize5MB: 'File size must not exceed 5MB',
    failed: 'Operation failed',
    saveFail: 'Save failed',
    modifyFail: 'Modify failed',
    loadFail: 'Load failed',
    claimFail: 'Claim failed',
    inviteFail: 'Invite failed',
    changeFail: 'Change failed',
    experienceFail: 'Experience failed',
    linkSuccess: 'Link successful',
    linkFail: 'Link failed',
    confirmSuccess: 'Confirm successful',
    editFail: 'Edit failed',
    orderQueryFail: 'Order query failed',
    submitFail: 'Submit failed',
    createSuccess: 'Create successful',
    createFail: 'Create failed',
    addMaterialSuccess: 'Material added successfully',
    modifyMaterialFail: 'Modify material failed',
    addMaterialFail: 'Add material failed',
    deleteMaterialFail: 'Delete material failed',
    noData: 'No data',
    helpCenter: 'Help Center',
    closeSystem: 'Close System',
    accountSecurity: 'Account Security Center',
    exportDownload: 'Export & Download',
    codeSuccess: 'Verification code sent successfully',
    codeSendFailed: 'Verification code send failed',
    days: 'days',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to',
    filterPlaceholder: 'Enter search keyword',
    available: 'Available',
    selected: 'Selected',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    phoneVerify: 'Phone Verification',
    replaceVerifyPhone: 'Change Verification Phone',
    retrievePassword: 'Retrieve Password',
    retrievePasswordTip: 'Use the phone number bound to your account to retrieve password',
    codePlaceholder: 'Verification Code',
    getCodeAgain: 'Resend Code',
    send: 'Send',
    countDownResend: 'Resend in {n}s',
    loginDeprecNotice: 'This login entry will be officially closed on October 31, 2024. If your account has not been upgraded, please bind your phone number after login according to the system instructions. For questions, please contact Squirrel AI customer service.',
    close: 'Close',
    newPassword: 'New Password',
    pleaseEnterNewPassword: 'Enter new password',
    selectAll: 'Select All',
    serialNo: 'No.',
    tip: 'Tip',
    pleaseSelect: 'Please select',
    selectAgentPlaceholder: 'Please select agent ID/agent name',
    searchAgentPlaceholder: 'Enter agent ID/agent name to search',
    select: 'Select',
    name: 'Name',
    label: 'Payment Method:',
    amount: 'Recharge Amount:',
    total: 'Total',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    public: 'Public',
    private: 'Private',
    attention: 'Attention',
    goToExportDownload: 'Please go to ',
    importExport: 'Export & Import',
    goToExportDownloadSuffix: ' to download',
    notNow: 'Not Now',
    goToDownload: 'Go to Export & Download',
    changeVerifyPhoneTitle: 'Change Verify Phone - Identity Verification',
    changePhoneBindTitle: 'Change Phone - Bind New Phone',
    copySuccess: 'Copied successfully',
    more: 'More',
    view: 'View',
    copy: 'Copy',
    normal: 'Normal',
    disabled: 'Disabled',
    primaryTag: 'Primary',
    planningDept: 'Planning Dept',
    classHours: 'Class Hours',
    classHoursWithNum: '{n} Class Hours',
    unbound: 'Unbound',
    bindPhoneTip: 'After binding phone number, you can use it to log in and retrieve password',
    pinTop: 'Pin',
    viewDetail: 'View Detail',
    noPermissionContactAdmin: 'No permission. Please contact administrator.',
    noPermissionContactAgentAdmin: 'No permission. Please contact your distributor administrator.',
    noPermissionRestrictedPrefix: 'Your system usage has been restricted. Restriction reason: ',
    noPermissionContactCustomerService: 'Please contact customer service.',
    queryBalanceFailed: 'Query balance failed',
    accountCreateTip: 'After account creation, the status is "Pending Confirm". Accounts in this status cannot log in. The employee will receive a DingTalk invitation. After downloading DingTalk and accepting the invitation to join HQ, the account status will change from "Pending Confirm" to "Normal" and login will be enabled.',
    continue: 'Continue',
    accountUpgrade: 'Account Upgrade',
    accountUpgraded: 'Account Upgraded',
    accountUpgradeIntro: 'Upgrade your agent account to Squirrel AI account in one minute',
    squirrelAiAccount: 'Squirrel AI Account',
    upgradeBenefits: 'Benefits after upgrade:',
    unifiedAccount: 'Unified Account',
    unifiedAccountDesc: 'Manage all agent and analyst accounts with one phone number',
    security: 'Security',
    securityDesc: 'Bind phone and DingTalk to improve account security',
    joinTraining: 'Training',
    joinTrainingDesc: 'Join Squirrel DingTalk organization for training materials and latest features',
    upgradeNow: 'Upgrade Now',
    bindPhone: 'Bind Phone Number',
    bindPhoneDesc: 'We will create or bind Squirrel AI account based on your phone number',
    phoneForRecovery: 'Enter phone number for account recovery',
    scanToActivate: 'Scan to activate account',
    goToDingTalk: 'Complete upgrade via DingTalk',
    mergeAccount: 'Merge Accounts',
    mergeAccountDesc: 'If you have other agent accounts to merge, please add them one by one',
    accountList: 'Account List',
    addAccount: '+ Add Account',
    refresh: 'Refresh',
    contactService: 'Contact Squirrel AI customer service for issues',
    setFilterFirst: 'Please set filter conditions first',
    bindMobile: 'Bind Phone',
    modifyPassword: 'Change Password',
    exportDownloadLabel: 'Export & Download',
    // Common menu labels used as `$t('common.xxx')` (aliased to `app.xxx` in `src/i18n/index.js`)
    purchasingCenter: 'Purchasing Center',
    salesCenter: 'Sales Center',
    serviceCenter: 'Service Center',
    financeCenter: 'Finance Center',
    businessManagement: 'Business Management',
    innovationBusiness: 'Innovation Business',
    deliveryManagement: 'Delivery Management',
    agentServiceProvider: 'Agent Service Provider',
    headquartersTools: 'Headquarters Tools',
    configBackend: 'Backend Configuration',
    statisticalAnalysis: 'Statistical Analysis',
    warehouseManagement: 'Warehouse Management',
    agentManagement: 'Agent Management',
    resourceLibrary: 'Resource Library',
    referralHelpCenter: 'Referral Help Center',
    referralPerformanceQuery: 'For inquiries about referral performance and usage rules, please refer to the help center.',
    referralCustomerInRegionQuery: 'For inquiries about referral customers in region, please refer to the help center.',
    referralCustomerFirstContract: 'For the calculation rules and inquiries about the first contract payment reward for referring customers, please refer to the Help Center;',
    referralCustomerFirstContract2: 'For the calculation rules and inquiries about the first contract payment reward for referring customers, please refer to the Help Center;',
    referralCustomerInRegion: 'Referral Customer in Region',
    channelRebateService: 'For the calculation rules and inquiries about channel rebates and service fee rewards, please refer to the Help Center:',
    channelRebateService2: 'For the calculation rules and inquiries about channel rebates and service fee rewards, please refer to the Help Center:',
    storageFeeExemptionNotice: 'Storage Fee Exemption Notice',
    // Callout/call-line helper labels
    callLineBusy: 'Call lines are busy',
    outboundLineBusy: 'Outbound lines are busy',
    notMigrated: 'Not migrated',
    hardPhone: 'Hard Phone',
    timeDifferenceIs: 'Time difference is ',
    downloadCertTemplate: 'Download Certificate Template',
    dealerMiniProgram: 'Dealer Mini Program',
    headquartersNotice: 'Headquarters Notice',
    // Work order / entry account helper labels
    agent: 'Agent',
    dealer: 'Dealer',
    analyst: 'Analyst',
    analystAccount: 'Analyst Account',
    mainAccount: 'Main Account',
    subAccount: 'Sub Account',
    mobile: 'Mobile Phone',
    myWorkOrder: 'My Work Order',
    myCustomerService: 'My Customer Service',
    noCustomerFound: 'No customer found',
    noDeviceFound: 'No device found',
    openEntryAccount: 'Open Entry Account',
    learningMachine: 'Learning Machine',
    // Slider helper comparisons
    creditOrders: 'Credit Orders',
    rechargeFlow: 'Recharge Flow',
    bigStudyRoom: 'Big Study Room',
    // Freight / Duxue dialog helper texts
    texteu15: 'Cancel',
    texttnry: 'Freight Plan',
    '10': 'Tips',
    accountSecurityCenter: 'Account Security Center',
    targetReminder: 'Target Setting Reminder',
    remindLater: 'Remind Me Later',
    goToSet: 'Go to Set',
    newNotice: 'You have a new announcement',
    viewLater: 'View Later',
    viewNow: 'View Now',
    important: 'Important',
    emergency: 'Emergency',
    callinTip: 'Lead is calling in, please handle promptly!',
    leadName: 'Lead Name',
    leadPhone: 'Lead Phone',
    followStatus: 'Follow-up Status',
    calloutNotOpen: 'Outbound Not Activated',
    calloutNotOpenTip: 'Dear dealer, your outbound service is not activated. You can click "Go to Activate" to activate or renew.',
    thinkAgain: 'Think Again',
    goToOpen: 'Go to Activate',
    goToRecharge: 'Go to Recharge',
    calloutOverdue: 'Outbound Service Overdue',
    calloutOverdueTip: 'Dear dealer, your outbound service has exceeded the usage limit. You can click "Go to Recharge" to top up.',
    calloutBusy: 'Outbound Lines Busy',
    iKnow: 'I Understand',
    gotIt: 'Got it',
    calloutBusyTip: 'Outbound lines are busy. Available in approximately XX minutes.',
    callTips: 'Tips',
    callTipsContent: 'For better call quality, please use headphones with a microphone connected to your computer for outbound calls.',
    noMoreRemind: 'I understand, no need to remind again',
    continueCallout: 'Continue Outbound',
    // Global shell components (match master meaning; use $t('common.xxx'))
    ddModalJoinHqTitle: 'Join Squirrel Cloud HQ',
    ddModalJoinHqSubtitle: 'Get the agent playbook and learn operations fast',
    ddModalBulletIndustry: 'Understand the industry background',
    ddModalBulletSystem: 'Learn how to use the dealer system',
    ddModalBulletSales: 'Improve your sales and service skills',
    ddModalScanToJoin: 'Scan with DingTalk to join',
    ddModalTrainUnlockTitle: 'Unlock after completing DingTalk training',
    ddModalMobileLearn: 'Scan with mobile DingTalk to learn',
    ddModalDesktopLearn: 'Learn on desktop DingTalk',
    ddModalSignupFailed: 'Signup failed. Please try again later.',
    trainingBannerCountdownPrefix: 'Training countdown ',
    trainingBannerUrgentSuffix:
      ' day(s); if overdue, the catalog will be locked.',
    trainingBannerGoTrain: 'Go to training',
    headerPersonalCenter: 'Profile',
    editorPlacementAreaLabel: 'Component placement area',
    notFoundTitle: 'Page not found',
    notFoundTip: 'The page you are looking for does not exist or has been removed.',
    notFoundBackHome: 'Back to home',
    passwordResetSuccess: 'Password changed successfully. Please log in with the new password.',
    passwordResetFail: 'Password change failed',
    verifySuccess: 'Verification successful!',
    verifyFail: 'Verification failed!',
    editAccountSuccess: 'Account updated successfully!',
    editAccountFail: 'Account update failed!',
    creditOrderPayTip: 'Credit Order Payment Requirements',
    creditOrderPayDesc: 'After dealer sells and activates equipment for payment, the credit order balance needs to be paid. ',
    exemptTip: 'From the date of receiving the delivery voucher, within ',
    exemptTip2: ' days is the exemption period; vouchers within the exemption period are free of storage fees. See: ',
    exemptTip3: 'According to the above rules, as of yesterday you have ',
    exemptTip4: ' yuan of vouchers about to expire. Please place orders and pay as soon as possible. The system will charge storage fees for overdue vouchers.',
    doubleOrderTip: 'Double orders are provincial agents linking agent and dealer account cash for centralized procurement. See: ',
    agentAccountTip: 'Agent Account FAQ',
    subscriptionTip: 'Subscription tier definition and query',
    referralChannel: 'Referral & Channel',
    guinnessTitle: 'Guinness Certificate Application Notice:',
    guinnessP1: 'Electronic certificate application deadline is ',
    guinnessP2: '. Please apply before the deadline. Paper certificates are no longer accepted.',
    guinnessP3: 'Student name and English name will be used in the certificate. Please verify and fill in carefully.',
    guinnessP4: 'To ',
    guinnessP5: 'modify student name',
    guinnessP6: ', go to "Parent App - Learning Report" to modify. Contact customer service for issues. Fill in and modify English name on this page.',
    guinnessP7: 'Guinness electronic certificates are free. Paper certificates cost ¥300. Squirrel does not charge any fees.',
    guinnessP8: 'Electronic certificates can be downloaded after application. Paper certificates take longer to produce, please wait patiently.',
    studentNameCertNotice: 'Student name and English name will be used in the certificate. Please verify and fill in carefully.',
    ifWantTo: 'To ',
    modifyStudentName: 'modify student name',
    pleaseGoToParentApp: ', go to "Parent App - Learning Report" to modify. Contact customer service for issues. Fill in and modify English name on this page.',
    guinnessDigitalCertFree: 'Guinness electronic certificates are free. Paper certificates cost ¥300. Squirrel does not charge any fees.',
    guinnessCertDownloadWait: 'Electronic certificates can be downloaded after application. Paper certificates take longer to produce, please wait patiently.',
    startCallout: 'Start Outbound',
    endCallout: 'End Outbound',
    calloutOnlineSuccess: 'Outbound service online successfully',
    calloutOfflineSuccess: 'Outbound service offline successfully',
    micPermissionFail: 'Microphone permission failed. Please check your browser settings.',
    getCustomerFail: 'Failed to get customer information!',
    pleaseStartCallout: 'Please click "Start Outbound" in the top right corner before making calls.',
    serviceError: 'Service error!',
    exportTaskSubmitted: 'Export task submitted successfully',
    pleaseProvideApiUrl: 'Please provide API URL',
    exportFailed: 'Export failed',
    systemError: 'System error. Please contact administrator',
    confirmRemoveFile: 'Confirm to remove {name}?',
    uploadImage: 'Upload Image',
    cancelUpload: 'Cancel Upload',
    clickUpload: 'Click to Upload',
    within100Chars: 'Within 100 characters',
    cancelUploadConfirm: 'Your entered information will be lost if you cancel. Confirm?',
    uploadImageFail: 'Upload failed. Please delete and re-upload.',
    pleaseUploadImage: 'Please upload an image!',
    pleaseReupload: 'Please re-upload',
    selectCommodity: 'Select Commodity',
    pleaseSelectJumpType: 'Select jump type',
    pleaseSelectImageLink: 'Select image jump link',
    pleaseEnterLink: 'Enter link (ensure it is accessible)',
    searching: 'Searching...',
    book: 'Book',
    other: 'Other',
    pleaseSelectUser: 'Select user',
    pleaseEnterKeywordFilter: 'Enter keyword to filter',
    pleaseSelectProductType: 'Select product type',
    pleaseSelectCounter: 'Select counter',
    pleaseSelectProvinceCity: 'Select province/city/district',
    pleaseSelectProvinceCityDistrict: 'Select province/city',
    pleaseSelectFault: 'Select fault classification',
    pleaseSelectAgentRegion: 'Select agent region',
    startDatePlaceholder: 'Start date',
    endDatePlaceholder: 'End date',
    clearFilter: 'Clear filter',
    collapse: 'Collapse',
    expand: 'Expand',
    query: 'Query',
    clear: 'Clear',
    pleaseFillRequired: 'Please fill in required fields!',
    requiredField: 'This field is required',
    invoiceQtyDecimalQ: 'Q: Why can invoice quantity be a decimal?',
    invoiceQtyDecimalA: 'A: The withdrawal amount of loan type is the money transferred from subordinate dealers\' order payment to the agent\'s withdrawal account. Squirrel has already issued sales invoices for dealers\' orders. When this loan is withdrawn again, it needs to be red-stamped or reverse sales invoices issued to Squirrel based on the original order\'s product model, unit price, and amount. According to the withdrawal amount applied this time used for different orders\' loans, different invoice amounts will be generated. With fixed amount and unit price, the quantity becomes a decimal.',
    socketConnectFailRetry: 'Unable to connect to message system. Please check network and retry.',
    socketConnectFailClose: 'Unable to connect to message system. Please close the system and retry.',
    transferSuccess: 'Transfer successful',
    transferFail: 'Transfer failed',
    noPermissionAskSuperior: 'No permission. Please ask your superior to grant access.',
    pleaseSelectAdPosition: 'Select ad position',
    pleaseEnterAdName: 'Enter ad name',
    pleaseEnterSort: 'Enter sort order',
    pleaseSelectStatus: 'Select status',
    pleaseSelectDisplayScope: 'Select display scope',
    publishSuccess: 'Published successfully',
    codeSentViewOnPhone: 'Verification code sent. Please check your phone.',
    pleaseEnterContactName: 'Enter contact name',
    pleaseEnterCorrectPhoneNum: 'Enter correct phone number',
    passwordSafetyTip: 'For account security, please update your password in time',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    pleaseEnterOldPassword: 'Enter current password',
    pleaseEnterNewPassword: 'Enter new password',
    pleaseConfirmNewPassword: 'Confirm new password',
    pleaseEnterNewPasswordAgain: 'Please enter the new password again',
    passwordMismatch: 'New passwords do not match',
    pleaseReenterNewPassword: 'Please re-enter new password',
    cancel: 'Cancel',
    confirm: 'Confirm',
    newNotice: 'You have a new announcement',
    viewNoticeDetail: 'View Announcement Details',
    tip: 'Tip',
    confirmDelete: 'Confirm to delete?',
    confirmClose: 'Confirm to close?',
    confirmReturnFreight: 'Confirm to refund freight?',
    returnFreightSuccess: 'Refund successful',
    returnFreightFail: 'Refund failed',
    returnGoodsTip: 'After return, device SN will be returned and delivery info will be deleted. Please operate with caution!',
    returnGoodsSuccess: 'Return successful',
    pleaseEnterPhoneForCode: 'Please enter phone number',
    codeSentSuccess: 'Verification code sent successfully',
    codeSentFail: 'Verification code send failed',
    passwordResetSuccess: 'Password reset successfully. Please log in with the new password.',
    passwordResetFail: 'Password reset failed',
    login: 'Login',
    passwordLogin: 'Password Login',
    phoneLogin: 'Verification Code Login',
    usernamePlaceholder: 'Enter username/phone number',
    passwordPlaceholder: 'Enter password',
    phone: 'Phone Number',
    password: 'Password',
    verifyCode: 'Verification Code',
    getCode: 'Get Code',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    verifySuccess: 'Verification successful',
    pleaseEnterPhone: 'Please enter phone number',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterVerifyCode: 'Please enter verification code',
    pleaseEnterOriginalPhone: 'Please enter original phone number',
    pleaseEnterNewPhone: 'Please enter new phone number',
    invalidPhone: 'Please enter a valid phone number',
    bindSuccess: 'Bind successful',
    upgradeSuccess: 'Your account has been upgraded to Squirrel AI account. Please log in from the unified login platform.',
    permissionError: 'Your access permission is abnormal. Please contact customer service for assistance.',
    requestFailed: 'Request failed',
    verifyFailed: 'Verification failed',
    codeSentTip: 'Verification code sent. Please check your phone.',
    popupWillCloseIn: 'Popup will close in',
    secondsAutoClose: 'seconds',
    auto_1_33bb0b88: 'Large Model Data Analysis Service',
    unsupervisedStudentDataTip: 'For students without supervision, view learning analytics in the Large Model Data Analysis Service System',
    auto_1_4419517d: 'Shanghai Putuo District Jinsha River Road',
    auto_11_3c1407e3: 'This payment will deduct',
    auto_12_21efd9b0: 'Label',
    auto_14_7788d61a: 'Airtime Unit Price',
    auto_15_6c5f790c: 'Agreement',
    auto_17_8032e637: 'Pay',
    auto_18_68eb91fb: 'Original price',
    auto_19_6aed0f56: 'No Limitren shu han',
    auto_20_a2a536d4: 'Auto-renew at expiration',
    auto_21_febbef1e: 'Label',
    auto_26_f93ba179: 'Flexible usage',
    auto_28_1d2a816b: 'Agreement',
    auto_30_fc80b0ff: 'Pay',
    auto_31_5b3591c1: 'No Limitren shu han',
    auto_32_34c314f2: 'Auto-renew at expiration',
    auto_35_056836b2: 'Flexible usage supports refunds',
    auto_36_2c8b792e: 'Agreement',
    auto_38_657cc6d0: 'Pay',
    auto_39_29fb07b1: 'Select layout area and add images below',
    auto_41_3411d78e: 'Width',
    auto_42_0daf419f: 'Width',
    auto_43_353730c1: 'Width',
    auto_44_2ffcd381: '',
    auto_46_c3fb5864: '',
    auto_48_0aa3291b: '',
    auto_50_d009fe60: '',
    auto_52_bfa198af: '',
    auto_52_cd58f41b: 'Please enter activation months first',
    auto_53_9153b4fc: 'Please read and check the outbound call service first',
    auto_54_014575b8: '',
    auto_54_21ddab8a: 'Please enter a valid airtime amount first',
    auto_55_4577be6a: 'Please read and check the outbound call service first',
    auto_56_9329c308: '',
    auto_56_cea773ed: 'Payment Success',
    auto_58_aaa2e80b: 'Purchase successful',
    auto_59_a1e1594b: 'Payment failed',
    auto_60_6c08e91d: 'Next',
    auto_60_d977a26d: 'Please add image',
    auto_61_84f03fb0: 'Click to replace image',
    auto_62_b7fb536e: 'Minework order',
    auto_62_efa11156: 'Verification successful',
    auto_63_9c495a0c: 'A work order will be submitted to technical experts for processing',
    auto_63_c72e441b: 'Replace the bound phone number with a new mobile phone',
    auto_65_5b3129b0: 'Verification code error',
    auto_66_3d5ad168: 'Phone Verification',
    auto_66_4c74e75e: 'Completed Work Orders',
    auto_67_2240de22: 'Cancel',
    auto_67_99c2c990: 'For completed work orders, technical experts have replied. You can click a work order to view details',
    auto_68_3c08da52: 'Confirm',
    auto_68_419e05d6: 'New progress',
    auto_69_31ad8c59: 'Your work orders are being processed. Please wait for the technical expert response',
    auto_69_b96f9f4f: 'Login failed',
    auto_70_1ee3a0b3: 'In-progress work order',
    auto_70_9ca27d68: 'Supporting Document',
    auto_71_44fb8798: 'Close',
    auto_71_6d2b1005: 'For in-progress work orders, customer service has submitted your request. Please wait for technical expert reply',
    auto_72_794828ac: 'All your work orders are completed. Please check the completed work orders for expert replies',
    auto_73_0771c815: 'Submit for Audit',
    auto_73_32adfc8d: 'work orderDetail',
    auto_74_f6fd4c00: 'work orderInformation',
    auto_75_38ddfcc9: 'EnterStudent Account',
    auto_75_95cc1a8c: 'work orderID',
    auto_76_40dca735: 'work orderTitle',
    auto_76_e734dd37: 'Description length in characters',
    auto_77_39620e02: 'work orderCreator',
    auto_78_0d0b0047: 'work orderCreate Time',
    auto_78_2d6f0fc5: 'Please upload the supporting document',
    auto_79_94495c94: 'Select audit result',
    auto_79_bd9cd84d: 'work orderStatus',
    auto_80_0cf9382a: 'work orderProcess By',
    auto_80_661f2449: 'Enter audit opinion',
    auto_81_36b9a3ac: 'ReviewCross-Entity SupervisionApplication',
    auto_81_3ac0816a: 'Work Order Completion Time',
    auto_82_403c2cbf: 'Issue handling result',
    auto_83_2933c8fe: 'Our technical experts are urgently processing your issue. Please wait patiently',
    auto_84_44eecdea: 'Cross-Entity SupervisionApplication',
    auto_84_c2300510: 'Select layout area and add images below',
    auto_85_7d350f62: 'Student AccountVerification failed',
    auto_86_492ffaa8: 'Student account verification failed, please try again later',
    auto_86_5646605a: 'Width',
    auto_87_0b2e5eb6: 'Width',
    auto_87_4591b39a: 'Only image files can be uploaded',
    auto_88_6d73238a: 'The uploaded file size cannot exceed',
    auto_88_9b344fb4: 'Width',
    auto_89_7953c2d5: 'FileUpload successful',
    auto_89_876f6ed4: '',
    auto_90_33e94845: 'FileUpload failed',
    auto_91_2869b272: 'ReviewReject',
    auto_91_2e80c943: '',
    auto_93_311be945: '',
    auto_94_15733a82: 'Pre-application validation failed',
    auto_95_294563f7: 'The application has already been reviewed; no need to resubmit',
    auto_95_d8daef36: '',
    auto_97_473f6ccf: '',
    auto_99_2d1fdf0f: '',
    auto_99_d0373366: 'No Need to Apply in Current Status',
    auto_100_b3dad3de: 'ReviewSubmitted successfully',
    auto_101_1a13328b: '',
    auto_102_d12681fa: 'Submit failed',
    auto_103_3a39ddcd: 'Label',
    auto_104_4c4e4b6f: 'Auxiliary blank',
    auto_105_9be7183a: 'Please add image',
    auto_106_6d719469: 'No margin',
    auto_106_ec081e14: 'Click to replace image',
    auto_107_f5a8f75f: 'Current quota',
    auto_108_8e48f7fd: 'Solid line',
    auto_108_e84a4be3: 'Limit',
    auto_109_cfe7889d: 'Dashed line',
    auto_110_20b0a497: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_110_b7b7726f: 'Dotted line',
    auto_111_80630d3f: 'Display',
    auto_112_cb755ac2: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_113_1c37f508: 'Display',
    auto_114_34e7eb5a: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_115_b9db9487: 'Normal',
    auto_116_10610081: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_117_7d189d5c: 'Normal',
    auto_118_b48a6ff1: 'Contact Phone',
    auto_119_0f491a54: 'Contact Address',
    auto_119_c860d08a: 'Square',
    auto_120_483ae5a2: 'Click to upload QR code',
    auto_121_95bbd0e8: 'Scan the QR code to follow the official account',
    auto_121_fe8681f1: 'Square',
    auto_123_1131d0ec: 'Drag with mouse to adjust product order',
    auto_123_7bc0c4f1: 'Align left',
    auto_125_206113c3: 'ClickAdd Goods',
    auto_125_59231844: 'Align left',
    auto_126_ef406980: 'Add Goods Groups',
    auto_127_3a945992: 'Drag with mouse to adjust group order',
    auto_127_3af34192: 'Display',
    auto_128_be01345d: 'ClickAdd Goods',
    auto_129_0cc92e04: 'Display',
    auto_129_abc25f15: 'Replace image',
    auto_130_fdb36e36: 'ClearImage',
    auto_131_32b40046: 'Image Advertisement',
    auto_131_99b24db8: 'Display',
    auto_132_858e59ff: 'Drag and drop the selected navigation to reorder it.',
    auto_133_05ace53e: 'Default Color',
    auto_134_7c4e567c: 'Default Color',
    auto_134_f4585f3e: 'ClickAddImage',
    auto_135_c0e8816b: 'Replace',
    auto_135_ebe23c00: 'Style 3',
    auto_137_36c54da9: 'Internal link',
    auto_138_afe8814b: 'External link',
    auto_139_3e9cf0db: 'Image Advertisement',
    auto_139_fe1e30e4: 'Image Navigation',
    auto_140_8a3667c7: 'Drag and drop the selected navigation to reorder it.',
    auto_141_6c3240d9: 'Fixed',
    auto_142_ce4845ab: 'ClickAddImage',
    auto_143_291e5905: 'Style 3',
    auto_143_8b644417: 'Internal link',
    auto_144_2e5a1856: 'External link',
    auto_145_fc8451c9: 'Display',
    auto_147_12a0fb3b: 'Display',
    auto_147_83c3e7b8: 'Purchase Amount',
    auto_148_b7220f0c: 'Paid Amount',
    auto_149_4e1fcefb: 'Option 2: Freight Prepaid',
    auto_149_b8ae9af9: 'Display',
    auto_151_e6478584: 'Label',
    auto_152_35641460: '',
    auto_152_7819c2cf: 'Label',
    auto_153_6dc7a4dc: 'Label',
    auto_154_b90eeb18: 'Label',
    auto_155_362485d0: 'Drag with mouse to adjust product order',
    auto_155_d4ce2cfe: 'Label',
    auto_156_83ec52fd: 'Label',
    auto_157_258d6836: 'Label',
    auto_157_ced864cd: 'ClickAdd Goods',
    auto_158_15475824: 'Label',
    auto_158_c1ed9b07: 'Add Goods Groups',
    auto_159_1ab4c4e6: 'Drag with mouse to adjust group order',
    auto_159_f61a0ab5: 'Label',
    auto_160_1b145402: 'ClickAdd Goods',
    auto_160_33d8ef3f: 'Horizontal scrolling',
    auto_161_1d135fe4: 'Replace image',
    auto_161_e28f6ced: 'Label',
    auto_162_c13a6592: 'ClearImage',
    auto_163_4adbf233: 'Label',
    auto_163_da664320: 'Image Advertisement',
    auto_164_91fcbc07: 'Drag and drop the selected navigation to reorder it.',
    auto_166_e5692185: 'ClickAddImage',
    auto_167_1e397a1f: 'Style 3',
    auto_167_ef6a4dce: 'Label',
    auto_168_39c0e6ef: 'Horizontal scrolling',
    auto_171_0a1546e8: 'Image Advertisement',
    auto_172_0f482ed0: 'Drag and drop the selected navigation to reorder it.',
    auto_174_756428f4: 'Label',
    auto_174_8d034751: 'ClickAddImage',
    auto_175_0910f3f5: 'Style 3',
    auto_175_56efd339: 'Label',
    auto_176_448098ad: 'Label',
    auto_177_0ec2a2f9: 'Label',
    auto_178_8172d6c2: 'Label',
    auto_179_07abf4f5: 'Label',
    auto_179_71c7a446: 'Freight',
    auto_180_263ed7bb: 'Paid Amount',
    auto_180_6d92ed35: 'Label',
    auto_181_2f47ecd4: 'Internal link',
    auto_181_f43952fb: 'Purchase Amount',
    auto_182_19566a20: 'External link',
    auto_182_b06ed898: 'Paid Amount',
    auto_183_314d8e1d: 'Label',
    auto_183_bd0c8844: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_184_b68fb5c2: 'Voucher Example',
    auto_185_1f46ba2d: 'Payment',
    auto_186_88a9b233: 'Payment',
    auto_187_8434ac96: 'Scan with WeChat',
    auto_189_aec5533f: 'Payment',
    auto_190_129ab638: 'Scan with Alipay',
    auto_190_4bfb417c: 'Label',
    auto_191_ff1cbeb7: 'Label',
    auto_192_0bca3c45: 'QR code URL invalid',
    auto_192_cbb3d8a7: 'Label',
    auto_193_4fec09ce: 'Bank Transfer',
    auto_193_69fe8e0b: 'Label',
    auto_194_1e880e51: 'Internal link',
    auto_194_a5ebb961: 'Recharge Now',
    auto_195_29a2a0d0: 'External link',
    auto_195_e8fdcebd: 'Scan with Alipay',
    auto_196_a5c0c783: 'Navigation horizontal scrolling',
    auto_196_c0f4727d: 'Scan with WeChat',
    auto_197_bba92391: 'QR code URL invalid',
    auto_198_001d1ca7: 'Recharge successful',
    auto_201_f39f2c7c: 'Label',
    auto_202_e1df8ae2: 'Label',
    auto_203_11d73e79: 'Label',
    auto_204_0ca2eced: 'Label',
    auto_205_4c88b486: 'Internal link',
    auto_206_fa76f700: 'External link',
    auto_207_9fb081bd: 'Navigation horizontal scrolling',
    auto_211_deed34c7: 'Style 3',
    auto_212_4503564c: 'Label',
    auto_213_58061322: 'Label',
    auto_214_1082a64e: 'Style 3',
    auto_214_3336d015: 'External link',
    auto_215_67625bb7: 'Label',
    auto_216_388b91ad: 'Background Image',
    auto_216_cbf8c407: 'Label',
    auto_217_257b91c3: 'Label',
    auto_217_e38e454c: 'Label',
    auto_218_58caab8c: 'Replace image',
    auto_218_9a3067d4: 'Label',
    auto_219_73f2d631: 'Shop Avatar',
    auto_219_8869a09b: 'Display',
    auto_220_53a18a03: 'Replace image',
    auto_221_7765c9c3: 'Display',
    auto_223_37242506: 'Display',
    auto_225_9b20333f: 'Display',
    auto_226_617d2ffb: 'Freight',
    auto_227_83a6eea2: 'Paid Amount',
    auto_227_ceb82976: 'Display',
    auto_228_0a0ca324: 'Pay Method',
    auto_229_557e21d9: 'Bank Transfer',
    auto_229_9de0f846: 'Display',
    auto_230_1168dd53: 'Payment',
    auto_231_84457b4b: 'Internal link',
    auto_231_c487af43: 'Style 3',
    auto_232_86bacd9f: 'External link',
    auto_233_666311fc: 'Label',
    auto_234_bde23ce6: 'Label',
    auto_234_db2690ba: 'External link',
    auto_235_0ce28284: 'Label',
    auto_236_174a0711: 'Background Image',
    auto_236_3e34fb8a: 'Label',
    auto_237_50875be3: 'Label',
    auto_237_ca96c211: 'Label',
    auto_238_e2bd33a4: 'Replace image',
    auto_238_e9fbdf6d: 'Label',
    auto_239_3622cba0: 'Horizontal scrolling',
    auto_239_d278c58b: 'Shop Avatar',
    auto_240_33d5a33e: 'Replace image',
    auto_240_4cc2cc6e: 'Label',
    auto_241_52383449: 'Label',
    auto_241_f85bb3b7: 'Sub Agent',
    auto_242_31de822c: 'Label',
    auto_244_5edba653: 'Internal link',
    auto_244_9d956674: 'Select agent',
    auto_245_7e73cd21: 'Sub Agent',
    auto_245_aa7a96f9: 'External link',
    auto_246_d56d107e: 'Here displays the note title at most',
    auto_247_94287073: 'Horizontal scrolling',
    auto_248_22f06bf6: 'Select agent',
    auto_249_2bd9ac7e: 'Label',
    auto_251_45cf4f1a: 'Please upload the proof of purchase for the supervisor service and the communication record with parents.',
    auto_252_0fa164da: 'Click to upload image',
    auto_253_2d63a546: 'Label',
    auto_253_9223791a: "A dynamic QR code is used to promote a user's personal WeChat account or fan group and is suitable for attracting users online and offline",
    auto_255_3d79d4c2: 'Replace image',
    auto_255_e2e12c71: 'Internal link',
    auto_256_1856931b: 'External link',
    auto_256_e084ac2b: 'Replace image',
    auto_257_4e50690b: 'Drag and drop the selected navigation to reorder it.',
    auto_257_7db1b71e: 'Book',
    auto_258_6c743df7: 'Click to add navigation',
    auto_258_d996f1e4: 'Other',
    auto_259_ec3152a9: 'Replace image',
    auto_259_fb3017dd: 'Searching...',
    auto_260_814044fe: 'ClearImage',
    auto_260_c50c825c: 'Test',
    auto_261_8c9ef40e: 'Test',
    auto_261_cc8cd318: 'Display',
    auto_262_2a868194: 'Label',
    auto_262_a7b4945a: 'No data',
    auto_263_1e2ac1cf: 'Label',
    auto_263_27550dc5: 'Max add',
    auto_264_fc834024: 'Label',
    auto_265_2be97a89: 'Label',
    auto_265_edec6409: 'Please note: accounts set as emergency contacts may be notified in very rare cases; generally no more than 3 times per month',
    auto_267_825914e3: 'Select Staff',
    auto_268_670ff28c: 'No need to set an emergency contact. Click the button on the right to cancel the reminder.',
    auto_269_def5443e: 'Get Code',
    auto_269_e283a2e6: 'Label',
    auto_270_57fefe83: 'Resend Code',
    auto_271_2d5d3117: 'Get Code',
    auto_272_4a32ae17: 'Resend Code',
    auto_273_0e2e46fd: 'This is the Xth follow-up and explanation of Squirrel AI advantages, etc. What subjects is the student interested in?',
    auto_273_aeb07a52: 'Failed to retrieve the emergency contact list.',
    auto_274_b45d5bf5: 'Label',
    auto_275_d188a12c: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_276_fc4e9f0c: 'Voucher Example',
    auto_277_6784f2d4: 'After removing students for multiple supervisors, their status remains unchanged',
    auto_277_db75769c: 'EmergencyContact',
    auto_280_267d7726: ' formal students',
    auto_281_18a00695: "A dynamic QR code is used to promote a user's personal WeChat account or fan group and is suitable for attracting users online and offline",
    auto_283_73880d23: 'Replace image',
    auto_284_1873ffa7: 'Replace image',
    auto_285_a5a7f524: 'Drag and drop the selected navigation to reorder it.',
    auto_285_c5128c5f: 'Submitted successfully',
    auto_286_6157bbfa: 'Click to add navigation',
    auto_286_e806378c: 'Submit failed',
    auto_287_6a946063: 'Replace image',
    auto_287_849374aa: 'Label',
    auto_288_5ef2f268: 'ClearImage',
    auto_289_f4701e29: 'Display',
    auto_290_c4d797dd: 'Label',
    auto_291_1815f84f: 'Max add',
    auto_293_be89a148: 'Related Agent Balance',
    auto_295_6e62aa26: 'Please select one of the following payment methods.',
    auto_296_0041b2e3: 'Voucher Example',
    auto_296_8f6d4c1d: 'Charge Item',
    auto_297_8abf3e2d: 'Unit Price',
    auto_298_2da831cc: 'Quantity',
    auto_298_fe25fbec: 'Payment',
    auto_299_39663d85: 'Drag and drop to adjust the hot-word order. By default, the search box shows the first hot word. Other search terms will be shown as tags.',
    auto_299_d9edcab4: 'Amount',
    auto_300_6fd6255e: 'Discount',
    auto_301_1c75938c: 'Amount After Discount',
    auto_301_c2563ff7: 'Click to add hot words',
    auto_302_6d7b34a0: 'Label',
    auto_302_f5bb943f: 'Label',
    auto_303_83ed12ab: 'Replace image',
    auto_303_c3435521: 'Please do not operate too frequently',
    auto_304_52a4dfe7: 'Shipment Success',
    auto_304_6c755347: 'ClearImage',
    auto_305_1d5f092c: 'Label',
    auto_305_69f78632: 'DeliverFailed',
    auto_306_24dad104: 'Payment failed',
    auto_307_c7ba6fe0: 'Click to add cards',
    auto_307_d9629eda: 'Payment failed',
    auto_308_09f5aa98: 'Label',
    auto_308_332d11c0: '',
    auto_309_6b77f0cb: 'Label',
    auto_310_ae6106e0: 'Label',
    auto_311_473f5dd4: 'Drag and drop to adjust the hot-word order. By default, the search box shows the first hot word. Other search terms will be shown as tags.',
    auto_311_b94dbcd5: 'Label',
    auto_312_86afba2d: 'Label',
    auto_313_2ae58c99: 'Label',
    auto_313_bded05d1: 'Click to add hot words',
    auto_314_28785eab: 'Label',
    auto_314_33f1fe82: 'Label',
    auto_315_75feb9f2: 'Replace image',
    auto_315_e5039ea1: 'Label',
    auto_316_6dbd0403: 'Label',
    auto_316_b1bdd575: 'ClearImage',
    auto_317_2b0717ec: 'Label',
    auto_317_9da5b447: 'Label',
    auto_318_bdf9a706: 'Payment Success',
    auto_319_acd760be: 'Click to add cards',
    auto_320_2f13c686: 'The bottom navigation bar is fixed at the bottom of the page; there is no need to drag to adjust its position.',
    auto_320_6d7330ec: 'Charge Item',
    auto_321_fd898be3: 'Unit Price',
    auto_322_bc3aabef: 'Quantity',
    auto_322_d314fa61: 'Label',
    auto_323_3ed4e1a5: 'Amount',
    auto_323_85f1a958: 'Click to add content',
    auto_324_01103e8f: 'Discount',
    auto_324_45261ca8: 'Change Verification Phone',
    auto_325_b684f2f3: 'Amount After Discount',
    auto_325_eb3c8bdb: 'Get Code',
    auto_326_53b37252: 'Label',
    auto_327_042286c8: 'Please do not operate too frequently',
    auto_328_13128576: 'The bottom navigation bar is fixed at the bottom of the page; there is no need to drag to adjust its position.',
    auto_328_dae8e444: 'Payment failed',
    auto_329_f7e1aacc: 'Payment failed',
    auto_330_bece925e: 'Payment failed',
    auto_330_cf582917: 'Label',
    auto_331_d23bf377: 'Click to add content',
    auto_332_a808c5c0: 'Export Report',
    auto_333_6802f7cf: 'Export Report',
    auto_334_227d711b: 'Export Report',
    auto_335_f142092c: 'Output',
    auto_336_6ffb1d8c: 'WeChat Pay',
    auto_336_898d3792: 'Download Import Template',
    auto_338_aa1e2682: 'Payment failed',
    auto_339_3c3af093: 'Get Code',
    auto_339_ed5ecea7: 'Payment failed',
    auto_340_0c616071: 'Upload official account image',
    auto_340_b4c0b3fb: 'Payment failed',
    auto_342_c9c920ec: 'This payment will deduct',
    auto_342_c9f03726: 'The customer status changes on the day after the supervisor study ends.',
    auto_343_12743d28:
      'Your Squirrel AI account has been frozen due to a long period of inactivity and security risk. To keep using it, you can wake the account.',
    wakeDialogDeferLogin: 'Not now',
    wakeDialogWakeNow: 'Wake now',
    wakeDialogDeferHandle: 'Remind me later',
    wakeDialogConfirmed: 'Confirmed',
    wakeDialogSecondMessage:
      'The Squirrel AI account under your ID {campusId} is being woken up. Please open DingTalk registered with {phone} and accept the team invitation to join HQ.',
    auto_343_1d32944f: 'Confirm',
    auto_344_1fc6be2a: 'Label',
    auto_344_b8289acd: 'Please select the supervision expiration time',
    auto_345_b57279bb: 'Please select the supervision store',
    auto_345_e6900270: 'ConfirmPublish',
    auto_346_8759d587: 'Name',
    auto_346_e7105895: 'Upload official account image',
    auto_347_221bceee: 'Stage/Grade',
    auto_348_7338083d: 'Learning center account',
    auto_349_d9ef97f6: 'Service Person',
    auto_350_a8adb4c9: 'Month(s)',
    auto_351_e566f31d: 'Month(s)',
    auto_352_eea985db: 'Month(s)',
    auto_353_fab3648e: 'Month(s)',
    auto_354_fd84dda6: 'Label',
    auto_355_b4384eb6: 'Primary School',
    auto_356_170c6c31: 'Junior High',
    auto_357_9e7d394b: 'Senior High',
    auto_358_de3dbeff: 'Pre-K',
    auto_359_e011300b: 'K1',
    auto_360_cd722ca1: 'K2',
    auto_361_694fc5e7: 'Grade 1',
    auto_362_4df5bd40: 'Grade 2',
    auto_363_7373adfb: 'Grade 3',
    auto_364_59a9aa58: 'Grade 4',
    auto_365_01ad86b3: 'Grade 5',
    auto_366_8ce6b148: 'Grade 6',
    auto_367_6ec28ee8: 'Grade 6',
    auto_368_0431dfa1: 'Grade 7',
    auto_369_d05aef19: 'Grade 8',
    auto_370_dc32dacc: 'Grade 9',
    auto_371_391d9d87: 'Grade 10',
    auto_372_b7098df1: 'Grade 11',
    auto_373_1888db71: 'Grade 12',
    auto_374_259e9142: 'Grade 13',
    auto_375_1177b2b7: 'Save failed',
    auto_376_b56ca628: 'Save failed',
    auto_384_0c33fbe1: 'Current access organization',
    auto_385_64f70ee4: 'Access account organization type',
    auto_386_bc3579ad: 'Access account level',
    auto_387_5f606fef: 'All access organizations',
    auto_389_c72ec969: 'Label',
    auto_398_5ad9a814: 'Confirm removing trial students',
    auto_400_4e3209c7: 'ConfirmRemoveStudent',
    auto_401_da364415: 'Confirm removing trial students',
    auto_402_78775655: 'ConfirmRemoveStudent',
    auto_403_94fa966b: 'Current Supervisor',
    auto_404_83e062bf: 'CurrentStatus',
    auto_405_24ed0186: 'Auxiliary blank',
    auto_407_33f9cbe0: 'No margin',
    auto_409_dfd0e873: 'Solid line',
    auto_410_09f7a574: 'Dashed line',
    auto_411_a379b0d5: 'Dotted line',
    auto_412_bdbd15b7: 'Display',
    auto_414_0e7d6384: 'Display',
    auto_416_9a85b398: 'Normal',
    auto_418_24814915: 'Normal',
    auto_420_9ff9fd92: 'Square',
    auto_422_06c31f6d: 'Square',
    auto_424_e8d3fde8: 'Align left',
    auto_426_8c38f1b5: 'Align left',
    auto_428_4420ad6e: 'Display',
    auto_430_dab76579: 'Display',
    auto_432_d26c4e85: 'Display',
    auto_434_4bce51c1: 'Default Color',
    auto_435_6682f6af: 'Default Color',
    auto_436_da266f2e: 'Replace',
    auto_438_c0a7db5f: 'Internal link',
    auto_439_c678cd52: 'External link',
    auto_440_e1702282: 'Image Navigation',
    auto_442_4ed3efd7: 'Fixed',
    auto_444_5cc58cb9: 'Internal link',
    auto_445_ec6fdc11: 'External link',
    auto_446_c3174bd3: 'Display',
    auto_448_2a8a960e: 'Display',
    auto_450_d4529d4d: 'Display',
    auto_452_bddb8735: 'Enter valid number',
    auto_453_82b92fb0: 'Label',
    auto_454_57eaab2b: 'Label',
    auto_455_21dc0c87: 'Label',
    auto_456_7ede69e7: 'Label',
    auto_457_b3d1b2a7: 'Label',
    auto_458_03989da0: 'Label',
    auto_459_e60df26f: 'Label',
    auto_460_93588292: 'Label',
    auto_461_e3a3762e: 'Label',
    auto_462_64a950fe: 'Horizontal scrolling',
    auto_463_c29b0da2: 'Label',
    auto_465_12701329: 'Label',
    auto_469_a412f003: 'Label',
    auto_470_f9cccea9: 'Horizontal scrolling',
    auto_476_493a15f7: 'Label',
    auto_477_045aa7df: 'Label',
    auto_478_ef701ad0: 'Label',
    auto_479_d9c11a16: 'Label',
    auto_480_a6cc2d22: 'Label',
    auto_481_d115a9bb: 'Label',
    auto_482_54da05b9: 'Label',
    auto_483_67431e6a: 'Internal link',
    auto_484_be9ac87b: 'External link',
    auto_485_e18fc47d: 'Label',
    auto_492_c72b1e91: 'Label',
    auto_493_46a12ceb: 'Label',
    auto_494_2cdb57d7: 'Label',
    auto_495_55b86c61: 'Label',
    auto_496_e145b007: 'Internal link',
    auto_497_239efe19: 'External link',
    auto_498_ba1aa155: 'Navigation horizontal scrolling',
    auto_503_a0e7e7ae: 'Label',
    auto_504_4c4cb749: 'Label',
    auto_505_008e901e: 'Label',
    auto_506_ad2fb054: 'Label',
    auto_507_a4371648: 'Internal link',
    auto_508_0257f830: 'External link',
    auto_509_29c74c2c: 'Navigation horizontal scrolling',
    auto_514_8b199476: 'Label',
    auto_515_693eed0f: 'Label',
    auto_516_d5f718b9: 'Style 3',
    auto_517_55c62973: 'Label',
    auto_518_8c050296: 'Label',
    auto_519_9158c62d: 'Label',
    auto_520_e62cf834: 'Label',
    auto_521_03942fb2: 'Display',
    auto_523_e85c1c82: 'Display',
    auto_525_60157788: 'Display',
    auto_527_2cf835ed: 'Display',
    auto_529_32a3367d: 'Display',
    auto_531_db197713: 'Display',
    auto_533_ff7f57b6: 'Internal link',
    auto_534_eafaa13f: 'External link',
    auto_535_45dba234: 'Label',
    auto_536_d8d41d1a: 'Label',
    auto_537_200e510a: 'Label',
    auto_538_3a99fd16: 'Label',
    auto_539_c06bd7aa: 'Label',
    auto_540_997720bf: 'Label',
    auto_541_a5a5eb74: 'Horizontal scrolling',
    auto_542_3c169032: 'Label',
    auto_543_9d579d33: 'Label',
    auto_544_a5ef145f: 'Label',
    auto_546_466f0afa: 'Internal link',
    auto_547_94cf8395: 'External link',
    auto_548_26ce1760: 'Here displays the note title at most',
    auto_549_54c8c4c1: 'Horizontal scrolling',
    auto_555_5e2685e6: 'Label',
    auto_557_214410b4: 'Internal link',
    auto_558_b8fa4fd9: 'External link',
    auto_559_0e34e723: 'Delete image',
    auto_560_ba0ce9b2: 'ReplaceImage',
    auto_561_92f2a573: 'Delete image',
    auto_562_b74e0f54: 'ReplaceImage',
    auto_563_1783ae38: 'Delete image',
    auto_564_41406e8c: 'ReplaceImage',
    auto_565_b0330cfc: 'Delete image',
    auto_566_e94396a0: 'ReplaceImage',
    auto_567_77dc8773: 'Delete image',
    auto_568_bc16c2f5: 'ReplaceImage',
    auto_569_4ddb639b: 'Staff will contact you within a few days',
    auto_570_6c22cb12: 'Please select the activity start and end time',
    auto_571_717a46b6: 'Activity Description Image',
    auto_572_45c0748d: 'Activity Rules Image',
    auto_573_b11b7ea1: 'Institution Introduction Image',
    auto_574_83746af1: 'Institution Introduction Image',
    auto_575_08a98c36: 'QR Code Image',
    auto_576_be030eaf: 'Cancel',
    auto_606_a265e358: 'Pre-K',
    auto_607_7145c0e4: 'K1',
    auto_608_0af2214b: 'K2',
    auto_609_f9520c05: 'Grade 1',
    auto_610_3461ac27: 'Grade 2',
    auto_611_955dc562: 'Grade 3',
    auto_612_d012d922: 'Grade 4',
    auto_613_ca3746b3: 'Grade 5',
    auto_614_a8846a79: 'Grade 6',
    auto_615_20c6c458: 'Grade 6',
    auto_616_c6723b3c: 'Grade 7',
    auto_617_770f4de9: 'Grade 8',
    auto_618_e0a5ada8: 'Grade 9',
    auto_619_a94c2ddd: 'Grade 10',
    auto_620_5a44415e: 'Grade 11',
    auto_621_ced1e3d8: 'Grade 12',
    auto_622_2b7e2b9c: 'Grade 13',
    auto_623_77451e5c: 'Deal Closed',
    auto_629_0678b836: 'Initiating Call',
    auto_630_10a00a86: 'Connected',
    auto_631_c32f7c23: 'Agent Ringing',
    auto_632_c3c6c0b6: 'Connecting',
    auto_633_3d13bc80: 'Call Ended',
    auto_634_f6020e93: 'Agent Idle',
    auto_635_820490f6: 'Calling',
    auto_636_10cc60c3: 'Playing Greeting',
    auto_637_4718bdad: 'Agent Answering',
    auto_638_f7a633c5: 'On Call',
    auto_639_4e4da016: 'This field is required',
    auto_640_2494517e: 'Select All',
    auto_641_5b463606: 'Label',
    auto_645_ce07e488: 'Label',
    auto_649_5399102b: 'Disable',
    auto_652_df79d2f5: 'Test',
    auto_653_9d8f1deb: 'Test',
    auto_654_bf5fe59a: 'Select All',
    auto_655_e2d64fef: 'Next',
    auto_657_51fb12ea: 'Verification successful',
    auto_658_966426c5: 'Verification failed',
    auto_666_60482caa: 'Internal link',
    auto_667_d7dcb490: 'External link',
    auto_668_728b44d2: 'Next',
    auto_670_c8e36f07: 'Verification code error',
    auto_671_29db97da: 'Verification code error',
    auto_672_eaf04f12: 'Internal link',
    auto_673_653949d5: 'External link',
    auto_676_c665a636: 'hanQ1 Performance',
    auto_677_2371f4ab: 'Label',
    auto_678_3edc269e: 'Label',
    auto_679_70568fa5: 'Cancel',
    auto_682_2a8ac5dc: 'Label',
    auto_683_79283b19: 'Only supports files in the specified format',
    auto_684_28a14bbf: 'Please upload image',
    auto_685_93ba3225: 'Please re-upload',
    auto_686_67ae8165: 'Continue Learning',
    auto_688_d90ce707: 'Request failed',
    auto_689_706fbc91: 'Request failed',
    auto_690_faf9e4bc: 'Label',
    auto_691_87642a19:
      'Your account has been disabled. Please contact your administrator or supervisor.',
    auto_692_698b1db8:
      'Your account has been disabled. Please contact your administrator or supervisor.',
    auto_693_bd7f79f4: 'Account woken up successfully',
    auto_694_777ce4cd: 'Wake up failed. Please try again later.',
    auto_695_6db324bb: 'Wake up failed. Please try again later.',
    auto_696_a5dbd8c2: 'Label',
    auto_697_23f1290c: 'ImageLoad failed',
    auto_698_780dddcd: 'Label',
    auto_699_a53fe93d: 'Cloud Warehouse Inventory Statistics',
    auto_702_48c87ede: 'Amount',
    auto_704_ff0bd18a: 'Custom Course Products',
    auto_705_0210c642: 'Product Name',
    auto_706_b21df977: 'Recharge Performance',
    auto_709_b58a2367: 'Confirm',
    auto_711_23695f4b: 'Purchasing Center',
    auto_712_ea6f60e7: 'Restriction reason',
    auto_1733_2683badf: 'To avoid affecting your outbound call business, based on your selected activation months, it will auto-renew by default after expiry',

    auto_13_c84c9c0a: 'Adjust the corresponding agent account and the corresponding futures order limit.',
    auto_22_19c4a75b: 'Can be turned off at any time',
    auto_25_3e832b4e: 'Can be turned off at any time',
    auto_27_d1819be1: 'Supports refunds',
    auto_45_303e37ca: 'Label',
    auto_47_2b37eaea: 'Label',
    auto_49_ce69d168: 'Label',
    auto_51_548e1408: 'Label',
    auto_53_df52d236: 'Label',
    auto_55_8a473108: 'Label',
    auto_57_23073796: 'Payment Failed',
    auto_57_92251487: 'Label',
    auto_58_b95fd9b8: '',
    auto_59_e3ad33aa: 'Label',
    auto_72_dea16466: 'Cancel',
    auto_74_4a659629: 'SubmitApplication',
    auto_90_9e04fb76: 'Label',
    auto_92_bb9c70b9: 'Label',
    auto_94_5ae0dde8: 'Label',
    auto_96_bd0583a6: 'Label',
    auto_98_e7619100: 'Label',
    auto_100_675c965a: 'Label',
    auto_101_34344d00: 'ApplicationSubmitted successfully',
    auto_102_74f23393: 'Label',
    auto_103_8969963d: '',
    auto_104_6164b9f8: 'Label',
    auto_105_591eb1d9: 'Label',
    auto_107_cd7d6781: 'Label',
    auto_112_62e20aa3: 'Label',
    auto_114_2ea46504: 'Label',
    auto_116_b284796a: 'Fixed when scrolling to the top',
    auto_118_eef46fd3: 'Fixed when scrolling to the top',
    auto_120_46ee5cef: 'Label',
    auto_122_151d2f40: 'Other Settings',
    auto_122_3ea10287: 'Label',
    auto_124_87dc5816: 'Label',
    auto_126_5c36ac58: 'Label',
    auto_128_5ddcf2f1: 'Label',
    auto_130_5c3e8624: 'Label',
    auto_132_5e227d58: 'Label',
    auto_136_2294e589: 'Add',
    auto_140_0eebdadc: 'textcharacterstext',
    auto_142_94863036: 'Label',
    auto_146_4655a856: 'Label',
    auto_148_bacaf968: 'Label',
    auto_150_bde0d922: 'Label',
    auto_162_c3fd44e9: 'Label',
    auto_220_54b5b650: 'Label',
    auto_222_e9e6d827: 'Label',
    auto_224_02f8bbea: 'Label',
    auto_226_11e4fbb7: 'Label',
    auto_228_dd3abf83: 'Label',
    auto_230_def5ae4f: 'Label',
    auto_243_da467e81: 'Label',
    auto_254_7d9cf14b: 'Scenarios for long-term maintenance by adding friends or fan groups',
    auto_254_7de05314: 'Label',
    auto_274_f55c1464: "What is the parent's attitude, whether a next follow-up has been scheduled, etc.",
    auto_278_a241fe24: 'Label',
    auto_279_63ad186a: 'Label',
    auto_280_4eee9e17: 'Label',
    auto_282_39e5777b: 'Scenarios for long-term maintenance by adding friends or fan groups',
    auto_288_2ce03110: 'Label',
    auto_289_78eeb1e3: 'Label',
    auto_294_7ef954c4: 'Account Balance',
    auto_319_e0bf7ef9: 'Payment Failed',
    auto_390_9c90503b: 'Processtext',
    auto_399_0204a557: 'ConfirmRemoveStudent',
    auto_406_eecda0aa: 'Label',
    auto_408_b0824788: 'Label',
    auto_413_f27eec55: 'Label',
    auto_415_240b2d57: 'Label',
    auto_417_f073eed7: 'Fixed when scrolling to the top',
    auto_419_88173eb3: 'Fixed when scrolling to the top',
    auto_421_5ba55c51: 'Label',
    auto_423_6c5c9370: 'Label',
    auto_425_8e22d440: 'Label',
    auto_427_9c8d6a58: 'Label',
    auto_429_de755e1b: 'Label',
    auto_431_5104032f: 'Label',
    auto_433_c3a3b8cb: 'Label',
    auto_437_c4a7674a: 'Add',
    auto_441_90304804: 'textcharacterstext',
    auto_443_34b8c7da: 'Label',
    auto_447_5808f99a: 'Label',
    auto_449_8d994a06: 'Label',
    auto_451_5b38e481: 'Label',
    auto_464_49011ed5: 'Label',
    auto_522_35bd42cb: 'Label',
    auto_524_2d5c1fe7: 'Label',
    auto_526_0f5d35fe: 'Label',
    auto_528_32dfabf2: 'Label',
    auto_530_9e8bd9c0: 'Label',
    auto_532_b58d720f: 'Label',
    auto_545_f6c84cd4: 'Label',
    auto_556_88c3b588: 'Label',
    auto_642_6743fcff: 'Label',
    auto_643_3d809b1a: 'Label',
    auto_644_48a91d08: 'Label',
    auto_646_0ff92362: 'Label',
    auto_647_e67df2d0: 'Label',
    auto_648_3fc04390: 'Label',
    auto_669_6e573553: 'Confirm',
    auto_687_479f10d7: 'Label',
    auto_703_44431f13: 'Tax Amount',
    auto_707_8c582976: 'Credit orders with unpaid amounts',
    auto_708_3447fc64: 'Label',

    auto_2_7eac2f18: 'Shanghai',
    auto_3_d02b13ac: 'Putuo District',
    auto_4_3d251ca5: 'Shanghai Putuo District Jinsha River Road',
    auto_16_649497cd: 'Agreement',
    auto_29_1b861332: 'Agreement',
    auto_37_e5314cea: 'Agreement',
    auto_40_7eb7a046: 'Select layout area and add images below',
    auto_61_423ca5e1: 'Next',
    auto_64_794b0be6: 'Label',
    auto_64_b77421ef: 'Replace the bound phone number with a new mobile phone',
    auto_65_2b441bf0: 'A work order will be submitted to technical experts for processing',
    auto_77_49a3410c: 'Description length in characters',
    auto_82_f114b59f: 'Cross-Entity SupervisionApplicationDetail',
    auto_83_ecad14f2: 'ReviewCross-Entity SupervisionApplication',
    auto_85_0c6b2447: 'Select layout area and add images below',
    auto_92_1364e0d6: 'Passed',
    auto_93_7dd3aeb1: 'ReviewReject',
    auto_96_0d7118c4: 'Monthly Quota Not Exceeded',
    auto_97_daafa233: 'Your Cross-entity Device Student Has',
    auto_98_ed78a387: 'The application has already been reviewed; no need to resubmit',
    auto_109_d9791baa: 'Limit',
    auto_124_6bb36468: 'Drag with mouse to adjust product order',
    auto_133_76b3a166: 'Drag and drop the selected navigation to reorder it.',
    auto_136_ae72634b: 'Label',
    auto_137_72ab3cd3: 'Label',
    auto_138_cd7bbb31: 'Style 3',
    auto_141_23df5fea: 'Drag and drop the selected navigation to reorder it.',
    auto_144_1d0b82ae: 'Label',
    auto_145_a5f5d11b: 'Label',
    auto_146_f57c1990: 'Style 3',
    auto_151_a1b97406: 'Option 2: Freight Prepaid',
    auto_156_0bd8a165: 'Drag with mouse to adjust product order',
    auto_164_f34f97e7: 'Label',
    auto_165_57d50e6d: 'Label',
    auto_165_cb52650a: 'Drag and drop the selected navigation to reorder it.',
    auto_166_5ccc47bb: 'Label',
    auto_168_fb5bb7e0: 'Label',
    auto_169_2f49db28: 'Label',
    auto_169_58cf2c9b: 'Label',
    auto_170_242cafcd: 'Label',
    auto_170_64e5757f: 'Style 3',
    auto_171_1a54ab1c: 'Label',
    auto_172_178edd16: 'Label',
    auto_173_1d26645d: 'Horizontal scrolling',
    auto_173_6de5a213: 'Drag and drop the selected navigation to reorder it.',
    auto_176_c98855c4: 'Label',
    auto_177_e58eb258: 'Label',
    auto_178_889a8746: 'Style 3',
    auto_184_c98f401b: 'Label',
    auto_185_0fcd7d54: 'Label',
    auto_186_ff05b364: 'Label',
    auto_187_2759dbce: 'Label',
    auto_188_6a461e5c: 'Scan with Alipay',
    auto_188_99efaa5e: 'Label',
    auto_189_01862b77: 'Label',
    auto_191_60623d74: 'Scan with WeChat',
    auto_197_8c7486a0: 'Label',
    auto_198_a2b3464e: 'Label',
    auto_199_08498f60: 'Label',
    auto_200_b99e418f: 'Navigation horizontal scrolling',
    auto_208_d13dc59b: 'Label',
    auto_209_2c4fec4d: 'Label',
    auto_210_16fe9f08: 'Label',
    auto_211_f6dbd0e5: 'Navigation horizontal scrolling',
    auto_212_c3e03ebe: 'Label',
    auto_213_d38d7b93: 'Style 3',
    auto_215_f2333149: 'External link',
    auto_232_60867bd9: 'Label',
    auto_233_80caa70c: 'Style 3',
    auto_235_92ff4fd0: 'External link',
    auto_242_bcb964f8: 'Superior Agent',
    auto_243_cbaa4988: 'Sub Agent',
    auto_246_b2f63ebb: 'Superior Agent',
    auto_247_f643a94e: 'Sub Agent',
    auto_248_6bd6c0a1: 'Label',
    auto_249_9cc46fdf: 'Horizontal scrolling',
    auto_250_de88cced: 'Label',
    auto_250_f993b2e0: 'Label',
    auto_251_9865162c: 'Label',
    auto_252_6d59eded: 'Horizontal scrolling',
    auto_266_16011053: 'Label',
    auto_267_38444dd7: 'Label',
    auto_268_eb95a4e9: 'Label',
    auto_270_d8e63225: 'Label',
    auto_271_2affd119: 'Label',
    auto_272_1f9e7cf3: 'Label',
    auto_275_08ad640c: 'Label',
    auto_276_e3c7f90a: 'Label',
    auto_278_3c291386: 'After removing the students under the current supervisor, their status will change to not being supervised',
    auto_279_9d974559: 'After removing students for multiple supervisors, their status remains unchanged',
    auto_281_b8fe3ff8: 'EmergencyContact',
    auto_297_5ac2955d: 'Voucher Example',
    auto_300_021b8a8a: 'Drag and drop to adjust the hot-word order. By default, the search box shows the first hot word. Other search terms will be shown as tags.',
    auto_306_b941cedd: 'Label',
    auto_312_be179ff5: 'Drag and drop to adjust the hot-word order. By default, the search box shows the first hot word. Other search terms will be shown as tags.',
    auto_318_0d696691: 'Label',
    auto_321_9639feab: 'The bottom navigation bar is fixed at the bottom of the page; there is no need to drag to adjust its position.',
    auto_329_273c4816: 'The bottom navigation bar is fixed at the bottom of the page; there is no need to drag to adjust its position.',
    auto_337_27dee8c1: 'WeChat Pay',
    auto_466_fa9e1655: 'Label',
    auto_467_eb6db3c3: 'Label',
    auto_468_aac4b0f6: 'Label',
    auto_471_2278d26d: 'Label',
    auto_472_3334f53e: 'Label',
    auto_473_de905509: 'Label',
    auto_474_8809c76f: 'Label',
    auto_475_0d4c933d: 'Horizontal scrolling',
    auto_486_4897ff13: 'Label',
    auto_487_248d92d0: 'Label',
    auto_488_1da4df9a: 'Label',
    auto_489_99d852bc: 'Label',
    auto_490_620280ad: 'Label',
    auto_491_aeeb07cb: 'Label',
    auto_499_cbc5aec3: 'Label',
    auto_500_64bdcf34: 'Label',
    auto_501_cf228456: 'Label',
    auto_502_95717bc1: 'Navigation horizontal scrolling',
    auto_510_dee125db: 'Label',
    auto_511_ad01c8e0: 'Label',
    auto_512_74b481d4: 'Label',
    auto_513_a3961ff9: 'Navigation horizontal scrolling',
    auto_550_c251ad87: 'Label',
    auto_551_9467c276: 'Horizontal scrolling',
    auto_552_72134306: 'Label',
    auto_553_47503a5b: 'Label',
    auto_554_e61f75d1: 'Horizontal scrolling',
    auto_578_fe32b009: 'ContinuePublish',
    auto_579_da6dbc03: 'Cancel',
    auto_624_a921024f: 'WeChat Added',
    auto_625_6dbd04d4: 'Promise Visit',
    auto_626_c3cdab96: 'Visited',
    auto_627_2c036380: 'Invalid',
    auto_628_680ad587: 'Deal Closed',
    auto_650_ef08637d: 'Disable',
    auto_656_2b7363ca: 'Next',
    auto_680_12d9e042: 'Confirm',
    auto_681_0fd13602: 'Cancel',
    auto_710_064217c6: 'Confirm',
    auto_1724_16ad7868: 'Label',

    auto_23_c7c89db7: 'Complete business onboarding and service activation within; in some regions where number resources are limited, the activation time may take longer.',
    auto_34_2e929559: 'Can be turned off at any time',
    auto_111_81f9bfcc: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_113_2e895df9: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_115_4001cd0b: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_117_f2e9b577: 'Supports JPG/PNG/GIF format in RGB mode, not exceeding 5MB',
    auto_150_4c7871e5: 'After receiving the goods, the amount paid to the courier may vary by up to 20; final amount prevails',
    auto_153_c2ab8b22: '2. For prepaid/collect shipping fees, you can choose voluntarily. If you waive the discount from prepaying the shipping fee, the discounted amount must be paid at receipt',
    auto_154_426cde05: '3. After collecting the prepaid/collect shipping fee, if this order is merged with other orders for delivery and meets the free-shipping conditions',
    auto_264_96fec72b: 'You can add up to 5 items',
    auto_266_ec12174c: 'Please note: accounts set as emergency contacts may be notified in very rare cases; generally no more than 3 times per month',
    auto_282_a4143e47: 'Not set',
    auto_283_b21e743a: 'Not set',
    auto_284_9b21a54d: 'Not set',
    auto_292_537dcd1d: 'You can add up to 5 items',
    auto_309_6f93698c: '2. For prepaid/collect shipping fees, you can choose voluntarily. If you waive the discount from prepaying the shipping fee, the discounted amount must be paid at receipt',
    auto_310_26fb9fa5: '3. After collecting the prepaid/collect shipping fee, if this order is merged with other orders for delivery and meets the free-shipping conditions',
    auto_577_09100b8f: 'Sensitive word detection',
    auto_651_fce225af: 'Normal',

  },
  // Service Center
  serviceCenter: {
    coinMall: 'Coin Mall',
    pickupStore: 'Pick-up Store',
    providePickupExchange: 'Provide pick-up store product exchange service',
    pickupExchangeDesc: 'After enabling pick-up store exchange, your students can place orders at the pick-up store',
    pickupStoreDisplaySetting: 'Pick-up Store Display Settings',
    productName: 'Product Name',
    enterProductName: 'Please enter product name',
    displaySwitchDesc: 'The display switch (will show in the pickup store when enabled)',
    productImage: 'Product Image',
    exchangePrice: 'Exchange Price',
    operation: 'Operation',
    enableSuccess: 'Enabled successfully',
    disableSuccess: 'Disabled successfully'
  },
  asEditor: {
    backActivityList: "Back to Activity List",
    stepTitleBasicInfo: "Basic Activity Info",
    stepTitleMarketingMaterial: "Marketing Materials",
    stepTitleReview: "Page Review",
    auto_1_59cf5f64: "View Operation Tutorial",
    auto_1_8c920303: "Page Title",
    auto_2_5371635d: "Reset",
    auto_2_6124d765: "Image Advertisement",
    auto_3_a8990461: "text",
    auto_3_e24c168e: "Image Advertisement",
    auto_4_7ea01090: "text",
    auto_4_f6e49da2: "Image Advertisement",
    auto_5_02873c22: "Squirrel Limited-time Activity",
    auto_5_7aecfac4: "text",
    auto_6_bb452d56: "View",
    auto_6_f2255260: "Previous",
    auto_7_3a6109f8: "Confirm",
    auto_7_afc01000: "Use General Template",
    auto_8_7905777d: "Edit complete: preview result",
    auto_8_7ec6ee4e: "Label",
    auto_9_55efd481: "Tip",
    auto_9_cf70301c: "Preview",
    auto_10_3a85785f: "ViewJSON",
    auto_10_9ae5ae83: "Confirm",
    auto_11_a9ede7c9: "Cancel",
    auto_11_c18162c3: "ImportJSON",
    auto_12_1db9bee1: "ExportJSON",
    auto_12_7f63d57a: "Image Advertisement",
    auto_13_03ee8a72: "Save",
    auto_13_bc2aec5c: "Image Advertisement",
    auto_14_33ef2ff7: "Label",
    auto_14_febf0bcd: "iPhone8Mobile Phonegao du",
    auto_15_6200fa9c: "text",
    auto_15_a2fa015c: "Tip",
    auto_16_3a051693: "text",
    auto_16_58d7a719: "Confirm",
    auto_17_0b3be60c: "text",
    auto_17_eeac68a9: "Cancel",
    auto_18_50ea7734: "textcannotbe emptytext",
    auto_18_e1e54ae8: "Label",
    auto_19_75e96370: "Start Date",
    auto_19_dc443ba0: "No LimitTime",
    auto_20_d3ef25f3: "End Date",
    auto_20_d74687a5: "Specify time",
    auto_21_37deb38e: "ActivityTitle",
    auto_21_b741d0eb: "Activityzai wei xin zhong fen xiang de ka pian yang shi",
    auto_22_17d82179: "Next",
    auto_22_9ec9bd6b: "ActivityDescription",
    auto_23_46ad2b24: "Activity Name",
    auto_23_90f5e9d6: "FillActivityBasic Info",
    auto_24_ddb80bb3: "Upload event marketing materials",
    auto_24_f07cb5f2: "Enter activity name",
    auto_25_5e199f9c: "ActivityTime",
    auto_25_fc33d4e0: "Review activity page effects",
    auto_26_7c73ad47: "ActivityTitle",
    auto_27_f0e1a8e1: "Enter activity title",
    auto_28_e6311ab7: "ActivityDescription",
    auto_29_658293df: "Enter activity description",
    auto_30_3f85201e: "Previous",
    auto_31_5ba29762: "ConfirmPublish"
  },
  channelAgents: {
    auto_1_50f0c2f6: "LeadStatus",
    auto_1_bcc4eca0: "Upgrade Application",
    auto_2_57e34a20: "First Contract Reward Ratio",
    auto_2_cf77705d: "Application Time",
    auto_3_1cd11945: "Referral Dealer Renewal Reward Ratio",
    auto_3_b8640dd0: "Audit Time",
    auto_4_a361b8d8: "Referrer",
    auto_4_b6a2b355: "Upgrade Application",
    auto_5_8edf6c66: "Referral Agent Name",
    auto_5_e3ef133a: "Upgrade to",
    auto_6_c5d37c9b: "Referrer Region",
    auto_6_d48837f6: "Please select",
    auto_7_6370bfd0: "Introducer",
    auto_7_b3e1df51: "Required Quota",
    auto_8_58f6b177: "Current Level",
    auto_8_c4154868: "Referrer Phone",
    auto_9_31823765: "Available Quota",
    auto_9_ff87ff59: "Customer Screenshot",
    auto_10_aec53ef9: "Remark",
    auto_10_af593915: "Reward Method",
    auto_11_5f0a4c24: "Current Channel Agent Level",
    auto_11_d4e95212: "Withdrawal Agent",
    auto_12_216edddb: "Status",
    auto_12_26977aef: "Withdrawal Agent Name",
    auto_13_5a9f7023: "Submitter Agent",
    auto_13_9842aea2: "aji",
    auto_14_d4a62bd1: "SubmitAgent Name",
    auto_14_f7a21f63: "bji",
    auto_15_c80f893e: "Submitter Region",
    auto_16_9c37a83e: "Customer Name",
    auto_17_6fd3cb0e: "Customer Phone",
    auto_18_9bafa9cb: "Customer Region",
    auto_19_71922b9a: "Customer Background",
    auto_20_3d186f73: "Follow-up Expansion Name",
    auto_21_94808661: "Expansion Screenshot",
    auto_22_a0bc721f: "Review Comment",
    auto_23_36a06e97: "guan lianChanneldai",
    auto_24_cedc8cdd: "guan lianChannel Agent Name",
    auto_25_23ad9f02: "Status",
    auto_26_7ecf0773: "Period",
    auto_27_efbff6d8: "Agent",
    auto_28_db1ffdb8: "gu dongName",
    auto_29_a20083fa: "tou ziAmountwan yuan",
    auto_30_a849f541: "text",
    auto_31_c83c19fa: "Songshu",
    auto_32_7cfa5436: "text",
    auto_33_f962ea2f: "Supplement",
    auto_34_5aacbc1f: "First time",
    auto_35_55d06364: "Reward Type",
    auto_36_5aacf3db: "ClickConfirmhouSubmitApplicationdao",
    channelAgentId: "Channel Agent ID",
    channelAgentName: "Channel Agent Name",
    currentChannelAgentLevel: "Current Channel Agent Level",
    cumulativeChannelAgentLevel: "Cumulative Channel Agent Level",
    status: "Status",
    effectiveCycle: "Validity Period",
    applyTime: "Application Time",
    applicant: "Applicant",
    auditOpinion: "Review Comment",
    creator: "Creator",
    createTime: "Create Time",
    remark: "Remark",
    equityInfo: "Equity Information",
    agent: "Agent",
    shareholderName: "Shareholder Name",
    investAmountWanYuan: "Investment Amount (10k CNY)",
    relatedChannelAgent: "Related Channel Agent",
    relatedChannelAgentName: "Related Channel Agent Name",
    period: "Period",
    changeLog: "Change Log",
    pleaseSelectStatus: "Please select status",
    applyStatusPendingReview: "Pending Review",
    applyStatusToBeSigned: "To Be Signed",
    applyStatusInEffect: "In Effect",
    applyStatusExpired: "Expired",
    applyStatusReturned: "Audit Rejected",
    applyStatusCancelled: "Cancelled",
    firstContractRewardRatio18: "First contract reward ratio",
    levelA13: "Level A",
    levelB14: "Level B",
    levelC15: "Level C",
    levelD16: "Level D",
    // PerformanceManagement — table column headers
    perfReferralCustomerId: "Referral Customer ID",
    perfReferralCustomerName: "Referral Customer Name",
    perfCustomerAccountOpenTime: "Customer Account Opened At",
    perfAccountOpenTime: "Account Open Time",
    perfSource: "Performance Source",
    perfPleaseSelectRewardType: "Please select reward method",
    perfPleaseSelectSource: "Please select performance source",
    perfContractLastPayTime: "Last Contract Payment Time",
    perfContractSignAmount: "Contract Amount",
    perfContractPaidAmountCol: "Contract Paid Amount",
    perfUsedQuota: "Used Quota",
    perfAvailableQuota: "Available Quota",
    perfIntroducerId: "Introducer ID",
    perfIntroducerName: "Introducer Name",
    perfWithdrawableAmount: "Withdrawable Amount",
    perfPayoutAgentId: "Withdrawal Agent ID",
    perfPayoutAgentName: "Withdrawal Agent Name",
    perfEffectiveAvailableTotal: "Total effective available quota: {amount} CNY",
    quotaUseType: "Usage Type",
    quotaUseLevel: "Upgrade To",
    quotaUseAmount: "Used Quota",
    quotaUseRemark: "Remark",
    quotaUseUser: "User",
    quotaUseTime: "Usage Time",
    quotaUseIntroducerId: "Introducer ID",
    quotaUseIntroducerName: "Introducer Agent Name",
    quotaUseDealerUpgrade: "Dealer Upgrade",
    quotaUseAgentDiscount: "Agent Discount",
    quotaUsePleaseSelectType: "Please select type",
    regionCurrentChannelAgentLevel: "Introducer Current Channel Agent Level",
    regionCumulativeAgentLevel: "Cumulative Channel Agent Level",
    regionPleaseSelectReferralCustomerId: "Please select the referral customer ID",
    regionPleaseSelectLevel: "Please select level",
    regionOrderAmount: "Order Amount",
    afpReferralCustomerId: "Referral Customer ID",
    afpReferralCustomerName: "Referral Customer Name",
    afpReferralContractAmount: "Referral Contract Amount",
    afpPurchaseOrderNo: "Purchase Order No.",
    afpPaymentStatus: "Payment Status",
    afpOrderStatus: "Order Status",
    afpProductName: "Product Name",
    afpPurchaseQuantity: "Purchase Quantity",
    afpDeliveryQuantity: "Delivery Quantity",
    afpPurchaseUnitPrice: "Purchase Unit Price",
    afpPurchaseTotalAmount: "Purchase Total Amount",
    afpContractPaidAmount: "Contract Payment Amount",
    afpCumulativeReturnedAmount: "Cumulative Returned Amount",
    afpDeliveryTime: "Delivery Time",
    afpRewardRate: "Reward Rate",
    afpRewardAmount: "Reward Amount",
    afpIsFirstTime: "Is First Time",
    afpSettlementYearMonth: "Settlement Year/Month",
    afpIntroducerOrChannelAgentId: "Introducer/Channel Agent ID",
    afpChannelAgentName: "Channel Agent Name",
    afpRegionalAgentId: "Regional Agent ID",
    afpRegionalAgentShareAmount: "Regional Agent Share Amount",
    crfReferralCustomerId: "Referral Customer ID",
    crfReferralCustomerName: "Referral Customer Name",
    crfPurchaseOrderNo: "Purchase Order No.",
    crfPaymentStatus: "Payment Status",
    crfOrderStatus: "Order Status",
    crfProductName: "Product Name",
    crfPurchaseQuantity: "Purchase Quantity",
    crfDeliveryQuantity: "Delivery Quantity",
    crfPurchaseUnitPrice: "Purchase Unit Price",
    crfPurchaseTotalAmount: "Purchase Total Amount",
    crfRenewOrderPaymentAmount: "Renewal Payment Amount",
    crfDeliveryTime: "Delivery Time",
    crfSubscriptionFeeAmount: "Subscription Fee Amount",
    crfRewardCoefficient: "Reward Coefficient",
    crfRewardGranted: "Reward Granted",
    crfSubscriptionFeeRebate: "Subscription Fee Rebate",
    crfValueAddedServiceFee: "Value-added Service Fee",
    crfSettlementYearMonth: "Settlement Year/Month",
    crfCumulativeChannelLevel: "Cumulative Channel Level",
    crfChannelAgentId: "Channel Agent ID",
    crfChannelAgentName: "Channel Agent Name"
  },
  inAndOut: {
    auto_1_139fd654: "text",
    auto_1_b9dc19e5: "Related Order",
    auto_2_2fd6123c: "bu fen shu ju cuo wu ruoConfirmdao",
    auto_2_40525a88: "Pickup No.",
    auto_3_9818d9d9: "Agent Name",
    auto_4_dea576f9: "Creator",
    auto_5_74d9ba3c: "Warehouse",
    auto_6_d1e81c55: "Consignee",
    auto_7_e043905b: "Receiver Phone",
    auto_8_73c2f4c1: "Province/City/District",
    auto_9_93c298c4: "Ship Status",
    auto_10_91f7dd37: "Cloud Warehouse Outbound Order No.",
    auto_11_cd5e206e: "Delivery Address",
    auto_12_7776b108: "Remark",
    auto_13_8d8a189e: "Related Order",
    auto_14_b13e13c2: "Pickup No.",
    auto_15_304026c0: "Agent Name",
    auto_16_d949d795: "Creator",
    auto_17_9577c244: "Warehouse",
    auto_18_5459cfcc: "Consignee",
    auto_19_f69fde8a: "Receiver Phone",
    auto_20_6f03a2c9: "Province/City/District",
    auto_21_df0b5b51: "Ship Status",
    auto_22_c08a1c9b: "Cloud Warehouse Outbound Order No.",
    auto_23_1fe87c25: "Delivery Address",
    auto_24_6d306963: "Remark",
    auto_25_92958a8d: "Transfer Order No.",
    auto_26_1b1e691e: "Agent Name",
    auto_27_1345f8be: "Creator",
    auto_28_9f7eb351: "Ship Warehouseku",
    auto_29_114d2d8e: "Ship Status",
    auto_30_10d00f1b: "text",
    auto_31_3077cfda: "Receive Warehouse",
    auto_32_6d5da67f: "Remark",
    auto_33_be3c245c: "Transfer Order No.",
    auto_34_6e471e75: "dan juStatus",
    auto_35_fe4361fd: "Submit Time",
    auto_36_4c3cba93: "yunWarehouseTransfer Order No.",
    auto_37_c77e7811: "Ship Status",
    auto_38_bbc449d3: "Creator",
    auto_39_a8a196d5: "Related Transfer Orderhao",
    auto_40_ed76ccca: "Remark",
    auto_41_f052cebf: "Download Import Template",
    auto_42_1c0777fe: "Import details",
    auto_43_07be94eb: "Download Import Template"
  },
  referral: {
    auto_1_17a24c7c: "shi fouConfirmyaoDeletegaiImage",
    auto_1_35aee83a: "Scan with WeChat to preview",
    auto_2_05b0a2c5: "Image Delete",
    auto_2_7cc4dc6c: "Preview",
    auto_3_8d8a0d0a: "Confirm",
    auto_3_9d5473a6: "Template Theme Image",
    auto_4_6bc3b01d: "Template Background Image",
    auto_4_cde7fb4a: "Cancel",
    auto_5_037ad60c: "shi fouConfirmyaoPublishgaiImage",
    auto_6_00c325b5: "Image Publish",
    auto_7_3a6109f8: "Confirm",
    auto_8_a478394a: "Cancel",
    auto_9_be2c267b: "shi fouConfirmyaoOff ShelfgaiImage",
    auto_10_6945e73a: "Image Off Shelf",
    auto_11_79b14662: "Confirm",
    auto_12_b6180373: "Cancel",
    auto_13_5eb2aadb: "Preview image",
    auto_14_7160357c: "Delete image",
    auto_15_df260266: "Preview image",
    auto_16_acb384af: "Delete image",
    auto_17_14df2a60: "Please select",
    auto_18_74d349b5: "Please select"
  },
  noviceTasks: {
    auto_1_334e5e27: "textAitext",
    auto_1_38604ac9: "text",
    auto_2_541d9670: "Confirm",
    auto_2_cc866735: "qian wangpurchase",
    auto_3_1f99f135: "text10text",
    auto_3_50099175: "text",
    auto_4_820c4504: "Label",
    auto_4_861380f9: "I Understand",
    auto_5_76791bc2: "yun ke tang xue xi zi ge yiClaim",
    auto_5_8ae23169: "Help Center",
    auto_6_6d258c8a: "text",
    auto_6_c9482bb1: "Tip",
    auto_7_3a6109f8: "Confirm",
    auto_7_4f1f7097: "AddSongshuAIHQqi ye wei xin"
  },
  pineconeBusiness: {
    auto_1_144af95b: "Cancel",
    auto_2_3f59f53b: "Submit",
    auto_3_43d3c963: "Open Experience Account",
    auto_4_8f9f1606: "Dealer",
    auto_5_c037cf10: "Exam Prep Province",
    auto_6_c8b7bdd1: "Student Mobile",
    auto_7_d69a6971: "Enter student mobile",
    auto_8_4240a3a7: "Student Name",
    auto_9_56564323: "Enter student name",
    auto_10_a0d4449d: "Stage/Grade",
    auto_11_593fdd20: "Select stage/grade",
    auto_12_0d9ebca8: "Experience Date",
    auto_13_92aec48d: "Select experience date"
  },
  systemManage: {
    auto_1_ea5a1f41: "Extension / Seat No.",
    auto_2_6eaed7f7: "Enter extension no.",
    auto_3_f5a4a6b9: "Enter seat no.",
    auto_4_889e956a: "Outbound Caller ID (mobile)",
    auto_5_74b44b16: "Enter outbound caller ID (mobile)"
  },
  loadingRedirect: 'Loading…',
}
